import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getBlogs = createAsyncThunk(
  "admin/allBlogs",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/blog/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addBlog = createAsyncThunk(
  "admin/addBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/blog/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const editBlog = createAsyncThunk(
  "admin/editBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/blog/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getSingleBlog = createAsyncThunk(
  "admin/singleBlog",
  async (blogId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/blog/${blogId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "admin/deleteBlog",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/blog/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  blogData: [],
  singleBlogData: [],
};

const blogSlice = createSlice({
  name: "blogSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBlogs.fulfilled, (state, action) => {
      state.blogData = action.payload.data;
    });
    builder.addCase(getSingleBlog.fulfilled, (state, action) => {
      state.singleBlogData = action.payload.data;
    });
  },
});

export default blogSlice.reducer;


